
export const IS_LOCALHOST = (location.hostname == 'localhost' || location.hostname == 'webapp' || location.hostname == 'test.gavlegardarna.se' || location.hostname.match(/ngrok.io/)) ? true : false
/**
 * Konstanter som förekommer i kodbasen.
 * Föredraget sätt i ifsatser
 *
 * Enbart för att koden blir mer lättläst om det står  blaa === RENTALOBJECT_TYPE_CODES.STUDENTBOSTAD än blaa === 'LGH20'
 */

/**
 * Om man använder vacanystore för att hämta ett rentalobjekt, men det inte är "vacant"
 */
export const NOT_A_VACANT_RENTALOBJECT = 'NOT_A_VACANT_RENTALOBJECT';

/**
 * Är ett rentalobjekt är av en viss typ.
 */
export const RENTALOBJECT_TYPE_CODES = {
  STUDENTBOSTAD: 'LGH20',
  STARTBO: 'LGH5',
  TRYGGHETSBOENDE: 'LGH2',
  TRYGGHETSBOENDE_PLUS: 'LGH4',
  RIVNINGSKONTRAKT: 'LGH6',
  LOKAL_TYP_1: 'LOK1',
  LOKAL_TYP_2: 'LOK2',
  LOKAL_TYP_4: 'LOK4',
  OVRIGT_TYP_1: 'ÖVR1'
}

/**
 * Vad man svarat på ett erbjudanden
 */
export const OFFER_RESPONSE_CODES = {

  NO: 'NEJ',
  YES: 'JA',

  // Dessa bör alltid kollas tillsammans.
  // Det är inte säkert svarskoden är NO_ANSWER_YET om man inte svarat. Ibland är den tom.
  EMPTY_ANSWER_CODE: '',
  NO_ANSWER_YET: 'EJ SVAR'
}

/**
 * Kan vara 'apartment', 'parking', 'premise'
 * Används bl.a. på subscripitons
 */
export const RENTALOBJECT_TYPES = {
  APARTMENT: 'apartment',
  PARKING: 'parking',
  PREMISE: 'premise',
  STUDENT_APARTMENT: 'studentapartment'
 // CULTIVATION: 'cultivation'
}


/**
 * Är man på sök-sidan, felanmälan kommersiella lokaler eller mina sidor?
 */
export const RENDERING_MODES = {
  MY_PAGES: 'mypages',
  SEARCH: 'search',
  COMMERCIAL_ERRORREPORT: 'commercial-errorreport',
  ONCALL_ERRORREPORT: 'oncall-errorreport',
  CHANGE_EMAIL_BANKID: 'change-email-bankid',
}

/**
 * Konstanter för marknadsplatser.
 * Se /api/lists/waitingListTypes
 */
export const WAITING_LIST_TYPES = {
  PARKING_DIREKT: 'Direkt, bil',
  PARKING_TORGET: 'Torget, bil',
  PREMISES_DIREKT: 'Direkt, förråd',
  PREMISES_TORGET: 'Torget, förråd',
  STUDENT_DIREKT: 'Direkt, student',
  STUDENT_TORGET: 'Torget, student',
  LGH_DIREKT: 'Direkt, lgh',


  // Används idagsläget enbart för att kolla om köplats får visas.
  UNGDOMSKAMPANJ: 'Ungdomskampanj'
}

export const PARKING_FILTER_TYPES = {
  CAR: ['C-PORT', 'K-GAR', 'K-GAR EGEN', 'PPL+MV', 'PPLATS', 'V-GAR', 'V-GAR DBUR', 'V-GAR EBUR', 'V-GAR EGEN'],
  MC: ['MC-GAR', 'MC-K-GAR', 'MC-K-GAR EGEN', 'MC-V-GAR', 'MC-V-GAR EBUR', 'MC-V-GAR EGEN'],
  CV: ['HUSV', 'PPHUSV'],
  BOAT: ['BÅTPL']
}

export const LOGIN_METHODS = {
  BANKID: 'bankid',
  USERNAME_PASSWORD: 'anvandarnamn',
  HASH: 'hash',
  CIAM: 'ciam'
}

/*
https://trello.com/c/SLztsJgu/87-testa-rentcontracts
Nu hämtas endast kontrakt av typen 1 (valid), 3 (coming), 5 (preliminarilyTerminated), 9 (terminated) och 10 (awaitingSignature) ut.
**/
export const CONTRACT_STATUSES = {
  VALID: 'valid', // 1 -- Gällande
  COMING: 'coming', // 3, -- Kommande
  PRELIMINARILYTERMINATED: 'preliminarilyTerminated',  // 5 -- Uppsagt preliminärt
  TERMINATED: 'terminated', // 9 -- Uppsagt
  AWAITING_SIGNATURE:'awaitingSignature' // 10 -- Väntar på underskrift
}

// https://trello.com/c/91fa0XEc/131-intresseanm%C3%A4lan-anv%C3%A4nd-logik-fr%C3%A5n-backend
/**
•	'none' om allt är okej och man får ansöka
•	'notLoggedIn' om man inte är inloggad
•	'maxAge' om man är för gammal
•	'minAge' om man är för ung
•	'notPublished' om objektstypen inte är publicerad (bör aldrig hända)
 */
export const NO_APPLY_REASONS = {
  NONE: 'none',
  NOT_LOGGER_IN: 'notLoggerIn',
  MAX_AGE: 'maxAge',
  MIN_AGE: 'minAge',
  NOT_PUBLISHED: 'notPublished',
  NO_APARTMENTCONTRACTS: 'tenancyContractRequired',
  NO_APARTMENTCONTRACTS_IN_VATAREA: 'vatArea',
  BLOCKED: 'blocked',
  TOO_OLD: 'TooOld',
  TOO_YOUNG: 'TooYoung',
  NOT_LOGGED_IN: 'NotLoggedIn',
  TOO_MANY: 'maxNotesOfInterestsReached',
  ALREADY_APPLIED: 'AlreadyApplied',
  COMPANY: 'company',
  SECONDARY_TENANT: 'secondaryRentalContract',
}

export const AUTH_STATUSES = {
  LOGGEDIN: true,
  NOT_LOGGEDIN: false,
  INVALID: 'invalid'
}

export const PREFERED_CONTACT_METHOD_VALUES = {
  LETTER: 'letter',
  EMAIL: 'email'
}

/*
[
  {
    "code": "BILPL1",
    "lowerAgeLimit": 18,
    "upperAgeLimit": null,
    "published": true,
    "caption": "Garage och carport"
  },
  {
    "code": "BILPL2",
    "lowerAgeLimit": 18,
    "upperAgeLimit": null,
    "published": true,
    "caption": "P-platser"
  },
  {
    "code": "BILPL4",
    "lowerAgeLimit": 18,
    "upperAgeLimit": null,
    "published": true,
    "caption": "P-platser (Endast torget)"
  },
  {
    "code": "LGH1",
    "lowerAgeLimit": 18,
    "upperAgeLimit": null,
    "published": true,
    "caption": "Bostadslägenhet"
  },
  {
    "code": "LGH2",
    "lowerAgeLimit": 55,
    "upperAgeLimit": null,
    "published": true,
    "caption": "55+"
  },
  {
    "code": "LGH20",
    "lowerAgeLimit": 18,
    "upperAgeLimit": null,
    "published": true,
    "caption": "Studentbostad"
  },
  {
    "code": "LGH3",
    "lowerAgeLimit": 18,
    "upperAgeLimit": 27,
    "published": true,
    "caption": "Ungdomskampanj"
  },
  {
    "code": "LGH4",
    "lowerAgeLimit": 65,
    "upperAgeLimit": null,
    "published": true,
    "caption": "Trygghetsboende"
  },
  {
    "code": "LGH5",
    "lowerAgeLimit": 18,
    "upperAgeLimit": 25,
    "published": true,
    "caption": "Startbo"
  },
  {
    "code": "LGH9",
    "lowerAgeLimit": 18,
    "upperAgeLimit": null,
    "published": true,
    "caption": "Nyproduktion"
  },
  {
    "code": "LOK3",
    "lowerAgeLimit": 18,
    "upperAgeLimit": null,
    "published": true,
    "caption": "Förråd"
  }
]
*/
